import { Controller } from "@hotwired/stimulus"

// Client-side filter for the Tests index page.
// Hides rows whose data-locale does not match the active question language.
// Tests with data-locale="" (locale=nil) stay visible in every state.
export default class extends Controller {
  static targets = ["pill", "row"]
  static values  = { activeLocale: String }

  connect() {
    this.apply(this.activeLocaleValue)

    // Re-apply after a Turbo morph (e.g. the theme-toggle form submits and
    // `redirect_back` morphs this same page). A morph strips the `hidden`
    // attributes we set below and preserves this element, so `connect` does
    // not fire again — without this the rows for every language reappear.
    this._reapply = () => this.apply(this.activeLocaleValue)
    document.addEventListener("turbo:morph", this._reapply)
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this._reapply)
  }

  select(event) {
    const locale = event.params.locale
    if (!locale || locale === this.activeLocaleValue) return
    this.activeLocaleValue = locale
    this.apply(locale)
  }

  apply(locale) {
    this.rowTargets.forEach(row => {
      const rl = row.dataset.locale
      row.hidden = rl !== "" && rl !== locale
    })
    this.pillTargets.forEach(pill => {
      const active = pill.dataset.testLanguageFilterLocaleParam === locale
      pill.setAttribute("aria-pressed", active ? "true" : "false")
    })
  }
}
